import React from 'react';
import { Link } from '@/lib/router-compat';
import { TrendingUp, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLang } from '@/i18n/useLang';

const COPY = {
  ro: {
    title: 'Evaluare auto',
    desc: 'Află valoarea mașinii tale în câteva secunde. Comparăm prețul cu anunțuri similare active.',
    cta: 'Evaluează acum',
  },
  en: {
    title: 'Car Valuation',
    desc: 'Find out your car\'s value in seconds. We compare it against similar active listings.',
    cta: 'Get valuation',
  },
  de: {
    title: 'Fahrzeugbewertung',
    desc: 'Erfahre den Wert deines Autos in wenigen Sekunden. Wir vergleichen mit ähnlichen aktiven Anzeigen.',
    cta: 'Jetzt bewerten',
  },
} as const;

const ValuationCTABanner: React.FC = () => {
  const t = COPY[useLang()];
  return (
    <section className="container mx-auto px-4 pt-6 pb-2">
      <div className="rounded-2xl border border-border bg-card p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4 shadow-sm">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
          <TrendingUp className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-serif text-lg md:text-xl text-foreground">{t.title}</h2>
          <p className="text-sm text-muted-foreground mt-1">{t.desc}</p>
        </div>
        <Link to="/evaluare-auto" className="w-full md:w-auto shrink-0">
          <Button className="w-full md:w-auto bg-accent hover:bg-accent/90 text-accent-foreground group">
            {t.cta}
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default ValuationCTABanner;
